/* eslint-disable */
/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Projected from the C# enums by AttireRent.Tests.CodeGen.TypeScriptEnums.
 * Regenerate with:  ATTIRERENT_UPDATE_GENERATED=1 dotnet test
 *
 * Values are the enum *names*, because that is how the API serialises them — a client
 * comparing against ordinals would break silently the day one is reordered.
 */

export const PermissionModuleValues = [
  'User',
  'Role',
  'Branch',
  'FinancialYear',
  'DocumentNumbering',
  'Tenant',
  'AuditLog',
  'Item',
  'ItemUnit',
  'Customer',
  'Vendor',
  'Package',
  'RateCard',
  'DamageChargeMaster',
  'ItemCategory',
  'ItemAttribute',
  'Party',
  'Availability',
  'RentalOrder',
  'ReturnInspection',
  'DepositSettlement',
  'CleaningJob',
  'AlterationJob',
  'FittingAppointment',
  'StockTransfer',
  'DeliveryJob',
  'Pos',
  'PurchaseOrder',
  'GoodsReceipt',
  'PurchaseBill',
  'SalesInvoice',
  'GstReturn',
  'CashAndBank',
  'Expense',
  'Asset',
  'VendorPayment',
  'Outstanding',
  'OwnersMoney',
  'BranchCashTransfer',
  'Employee',
  'Payroll',
  'Scheme',
  'Report',
] as const;

export type PermissionModule = (typeof PermissionModuleValues)[number];

export const PermissionActionValues = [
  'View',
  'Create',
  'Edit',
  'Delete',
  'Approve',
  'ViewFinancials',
  'Export',
  'Print',
  'Discount',
] as const;

export type PermissionAction = (typeof PermissionActionValues)[number];

export const FeatureCodeValues = [
  'MasterData',
  'UnitInventory',
  'Availability',
  'RentalOrders',
  'ReturnInspection',
  'Laundry',
  'Billing',
  'Alterations',
  'Packages',
  'Fittings',
  'CustomerRisk',
  'MultiBranch',
  'InterBranchTransfer',
  'Pos',
  'Purchase',
  'Delivery',
  'CashAndExpense',
  'Gst',
  'Payroll',
  'AssetManagement',
  'UnitRoiAnalytics',
  'AdvancedReporting',
  'SchemeEngine',
  'ExcelImport',
  'TallyExport',
  'WhatsAppNotifications',
] as const;

export type FeatureCode = (typeof FeatureCodeValues)[number];

export const PlanLimitKindValues = [
  'Users',
  'Branches',
  'TransactionsPerMonth',
  'StorageMegabytes',
] as const;

export type PlanLimitKind = (typeof PlanLimitKindValues)[number];

export const BillingPeriodValues = [
  'Monthly',
  'Quarterly',
  'Annual',
] as const;

export type BillingPeriod = (typeof BillingPeriodValues)[number];

export const ChargingModelValues = [
  'Subscription',
  'LicenceWithAmc',
  'Pilot',
] as const;

export type ChargingModel = (typeof ChargingModelValues)[number];

export const SubscriptionPaymentKindValues = [
  'Licence',
  'Amc',
  'Subscription',
  'Setup',
  'Complimentary',
] as const;

export type SubscriptionPaymentKind = (typeof SubscriptionPaymentKindValues)[number];

export const SubscriptionPaymentMethodValues = [
  'Upi',
  'Cash',
  'BankTransfer',
  'Cheque',
] as const;

export type SubscriptionPaymentMethod = (typeof SubscriptionPaymentMethodValues)[number];

export const BillingStandingValues = [
  'NoTerms',
  'Pilot',
  'Paid',
  'DueSoon',
  'Overdue',
  'ReadOnly',
  'Suspended',
  'NoSubscription',
  'Leaving',
] as const;

export type BillingStanding = (typeof BillingStandingValues)[number];

export const SubscriptionAccessStateValues = [
  'Trialing',
  'Active',
  'InGrace',
  'ReadOnly',
  'Suspended',
  'NoSubscription',
] as const;

export type SubscriptionAccessState = (typeof SubscriptionAccessStateValues)[number];

export const TenantStatusValues = [
  'Trial',
  'Active',
  'PastDue',
  'Suspended',
  'Cancelled',
] as const;

export type TenantStatus = (typeof TenantStatusValues)[number];

export const TenantOriginValues = [
  'PlatformProvisioned',
  'SelfSignup',
] as const;

export type TenantOrigin = (typeof TenantOriginValues)[number];

export const DocumentTypeValues = [
  'Quotation',
  'SalesOrder',
  'DeliveryChallan',
  'TaxInvoice',
  'JobWorkInvoice',
  'ScrapSaleInvoice',
  'CreditNote',
  'DebitNote',
  'PurchaseIndent',
  'PurchaseOrder',
  'GoodsReceiptNote',
  'PurchaseBill',
  'PurchaseReturn',
  'WorkOrder',
  'OutwardChallan',
  'InwardChallan',
  'RepairOrder',
  'QcInspection',
  'ProductionPlan',
  'StockTransfer',
  'StockAdjustment',
  'ScrapGeneration',
  'PaymentVoucher',
  'ReceiptVoucher',
  'ExpenseVoucher',
  'JournalVoucher',
  'ContraVoucher',
  'InwardGateEntry',
  'OutwardGatePass',
  'RentalOrder',
  'RentalAgreement',
  'ReturnInspectionNote',
  'DepositRefundNote',
  'CleaningChallan',
  'RentalQuotation',
  'RentalReceipt',
  'AlterationJob',
  'CleaningJob',
  'RentalTaxInvoice',
  'RentalTaxNote',
] as const;

export type DocumentType = (typeof DocumentTypeValues)[number];

export const FinancialYearStatusValues = [
  'Open',
  'SoftClosed',
  'Closed',
] as const;

export type FinancialYearStatus = (typeof FinancialYearStatusValues)[number];

export const PlatformRoleValues = [
  'ReadOnly',
  'Support',
  'SuperAdmin',
] as const;

export type PlatformRole = (typeof PlatformRoleValues)[number];

export const AttributeDataTypeValues = [
  'List',
  'Number',
  'Text',
] as const;

export type AttributeDataType = (typeof AttributeDataTypeValues)[number];

export const MediaTypeValues = [
  'Image',
  'Video',
] as const;

export type MediaType = (typeof MediaTypeValues)[number];

export const UnitStatusValues = [
  'Available',
  'Reserved',
  'OnRent',
  'AwaitingInspection',
  'InCleaning',
  'InAlteration',
  'InTransit',
  'Damaged',
  'Lost',
  'Retired',
  'Sold',
] as const;

export type UnitStatus = (typeof UnitStatusValues)[number];

export const UnitConditionValues = [
  'Unusable',
  'Poor',
  'Fair',
  'Good',
  'Excellent',
  'New',
] as const;

export type UnitCondition = (typeof UnitConditionValues)[number];

export const AvailabilityBlockTypeValues = [
  'Booking',
  'Cleaning',
  'Alteration',
  'Maintenance',
  'Transit',
  'Hold',
] as const;

export type AvailabilityBlockType = (typeof AvailabilityBlockTypeValues)[number];

export const GarmentTimelineSourceValues = [
  'None',
  'Status',
  'Block',
  'Booking',
  'Job',
] as const;

export type GarmentTimelineSource = (typeof GarmentTimelineSourceValues)[number];

export const IdDocumentTypeValues = [
  'Aadhaar',
  'Pan',
  'DrivingLicence',
  'Passport',
  'VoterId',
  'Other',
] as const;

export type IdDocumentType = (typeof IdDocumentTypeValues)[number];

export const VendorCapabilityValues = [
  'None',
  'Laundry',
  'Tailor',
  'Supplier',
] as const;

export type VendorCapability = (typeof VendorCapabilityValues)[number];

export const EmployeeCapabilityValues = [
  'None',
  'Tailor',
  'Laundry',
  'Counter',
  'Delivery',
] as const;

export type EmployeeCapability = (typeof EmployeeCapabilityValues)[number];

export const DocketLanguageValues = [
  'English',
  'Gujarati',
  'Hindi',
] as const;

export type DocketLanguage = (typeof DocketLanguageValues)[number];

export const BookingStageValues = [
  'Enquiry',
  'Quotation',
  'Hold',
  'Confirmed',
  'InProgress',
  'Completed',
  'Cancelled',
  'Expired',
  'Recovery',
] as const;

export type BookingStage = (typeof BookingStageValues)[number];

export const BookingListValues = [
  'Upcoming',
  'WithCustomers',
  'Done',
] as const;

export type BookingList = (typeof BookingListValues)[number];

export const GarmentStateValues = [
  'Pending',
  'Allocated',
  'Fitting',
  'Alteration',
  'Ready',
  'Issued',
  'Returned',
  'Inspected',
  'NotReturned',
  'Replaced',
  'Removed',
] as const;

export type GarmentState = (typeof GarmentStateValues)[number];

export const PaymentKindValues = [
  'Token',
  'RentalBalance',
  'Deposit',
  'DepositRefund',
  'LateFee',
  'DamageCharge',
  'MissingAccessory',
  'AlterationCharge',
  'CancellationFee',
  'RentalRefund',
] as const;

export type PaymentKind = (typeof PaymentKindValues)[number];

export const PaymentMethodValues = [
  'Cash',
  'Upi',
  'Card',
  'BankTransfer',
  'Cheque',
  'Adjustment',
] as const;

export type PaymentMethod = (typeof PaymentMethodValues)[number];

export const DepositCollectionPointValues = [
  'AtBooking',
  'AtPickup',
  'Split',
] as const;

export type DepositCollectionPoint = (typeof DepositCollectionPointValues)[number];

export const DepositRefundPointValues = [
  'AtCounter',
  'AfterInspection',
  'AfterCleaning',
] as const;

export type DepositRefundPoint = (typeof DepositRefundPointValues)[number];

export const DepositStateValues = [
  'NotTaken',
  'Held',
  'PartRefunded',
  'Refunded',
  'Forfeited',
  'AppliedToBalance',
] as const;

export type DepositState = (typeof DepositStateValues)[number];

export const InspectionOutcomeValues = [
  'Clean',
  'Repairable',
  'BeyondRepair',
] as const;

export type InspectionOutcome = (typeof InspectionOutcomeValues)[number];

export const ChargeApprovalStateValues = [
  'NotRequired',
  'Pending',
  'Approved',
  'Rejected',
] as const;

export type ChargeApprovalState = (typeof ChargeApprovalStateValues)[number];

export const DisputeStatusValues = [
  'Open',
  'Upheld',
  'Rejected',
  'Withdrawn',
] as const;

export type DisputeStatus = (typeof DisputeStatusValues)[number];

export const GarmentJobKindValues = [
  'Cleaning',
  'Alteration',
  'Repair',
] as const;

export type GarmentJobKind = (typeof GarmentJobKindValues)[number];

export const GarmentJobStatusValues = [
  'Pending',
  'Dispatched',
  'Received',
  'Completed',
  'ReCleanRequired',
  'DamagedInJob',
] as const;

export type GarmentJobStatus = (typeof GarmentJobStatusValues)[number];

export const AmendmentKindValues = [
  'Add',
  'Remove',
  'Swap',
  'AddWearer',
] as const;

export type AmendmentKind = (typeof AmendmentKindValues)[number];

export const GarmentPhotoPhaseValues = [
  'Out',
  'In',
] as const;

export type GarmentPhotoPhase = (typeof GarmentPhotoPhaseValues)[number];

export const PartyRoleValues = [
  'Customer',
  'Vendor',
  'Employee',
] as const;

export type PartyRole = (typeof PartyRoleValues)[number];

export const TaxDocumentKindValues = [
  'Invoice',
  'CreditNote',
  'DebitNote',
] as const;

export type TaxDocumentKind = (typeof TaxDocumentKindValues)[number];

export const TaxDocumentStatusValues = [
  'Issued',
  'Cancelled',
] as const;

export type TaxDocumentStatus = (typeof TaxDocumentStatusValues)[number];

export const TaxDocumentLineKindValues = [
  'Rental',
  'Alteration',
  'LateFee',
  'Damage',
  'AccessoryReplacement',
  'CancellationFee',
  'Sale',
] as const;

export type TaxDocumentLineKind = (typeof TaxDocumentLineKindValues)[number];

export const CashDirectionValues = [
  'In',
  'Out',
] as const;

export type CashDirection = (typeof CashDirectionValues)[number];

export const CashAccountKindValues = [
  'Till',
  'Bank',
  'PettyCash',
] as const;

export type CashAccountKind = (typeof CashAccountKindValues)[number];

export const CashSourceKindValues = [
  'RentalPayment',
  'Expense',
  'VendorPayment',
  'Transfer',
  'Opening',
  'Adjustment',
  'CashVoucher',
  'SalePayment',
] as const;

export type CashSourceKind = (typeof CashSourceKindValues)[number];

export const CashVoucherKindValues = [
  'OwnerIn',
  'OwnerOut',
  'OtherIncome',
] as const;

export type CashVoucherKind = (typeof CashVoucherKindValues)[number];

export const RecurrenceFrequencyValues = [
  'Monthly',
  'Weekly',
  'Yearly',
] as const;

export type RecurrenceFrequency = (typeof RecurrenceFrequencyValues)[number];

export const PurchaseOrderStatusValues = [
  'Open',
  'PartlyReceived',
  'Received',
  'Cancelled',
  'ClosedShort',
] as const;

export type PurchaseOrderStatus = (typeof PurchaseOrderStatusValues)[number];

export const PurchaseBillStatusValues = [
  'Unpaid',
  'PartPaid',
  'Paid',
  'Cancelled',
] as const;

export type PurchaseBillStatus = (typeof PurchaseBillStatusValues)[number];

export const PurchaseBillDifferenceKindValues = [
  'QuantityBeyondReceived',
  'RateDiffersFromOrder',
  'TotalDiffersFromPaper',
] as const;

export type PurchaseBillDifferenceKind = (typeof PurchaseBillDifferenceKindValues)[number];

export const VendorDueKindValues = [
  'Bill',
  'Job',
] as const;

export type VendorDueKind = (typeof VendorDueKindValues)[number];

export const SaleLineKindValues = [
  'Garment',
  'Other',
] as const;

export type SaleLineKind = (typeof SaleLineKindValues)[number];

export const SaleInvoiceStatusValues = [
  'Unpaid',
  'PartPaid',
  'Paid',
  'Cancelled',
] as const;

export type SaleInvoiceStatus = (typeof SaleInvoiceStatusValues)[number];

export const GarmentSaleRefusalValues = [
  'None',
  'AlreadySold',
  'Gone',
  'AwaitingInspection',
  'Held',
] as const;

export type GarmentSaleRefusal = (typeof GarmentSaleRefusalValues)[number];

export const SupplierEventKindValues = [
  'Order',
  'Delivery',
  'Bill',
  'Payment',
] as const;

export type SupplierEventKind = (typeof SupplierEventKindValues)[number];

export const ReceivableKindValues = [
  'Booking',
  'Sale',
] as const;

export type ReceivableKind = (typeof ReceivableKindValues)[number];

export const GarmentMovementKindValues = [
  'None',
  'HandedOver',
  'TakenBack',
  'ToCleaner',
  'FromCleaner',
  'ToTailor',
  'FromTailor',
  'BookedIn',
] as const;

export type GarmentMovementKind = (typeof GarmentMovementKindValues)[number];

/**
 * A single grant, in the wire format the API uses: `Module:Action`.
 *
 * Menu predicates and route guards are typed against this, so naming a permission that
 * does not exist is a compile error rather than a screen that silently never appears.
 */
export type Permission = `${PermissionModule}:${PermissionAction}`;

/** What the API sends in place of a grant list when a role holds everything. */
export const AllPermissions = '*';
